<template>
    <v-card>
        <v-toolbar flat dense color="blue-grey" dark>
            <v-toolbar-title>SMS Logg</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear indeterminate v-if="loading"/>
        <p v-else-if="smsLog.length === 0" class="pa-3 text-center grey--text">Ingen SMS funnet</p>
        <v-list three-line v-else class="log-list">
            <template v-for="(item, index) in smsLog">
                <div>
                    <v-divider v-if="index > 0"/>
                    <v-list-item :key="item.id">
                        <v-list-item-content>
                            <v-list-item-title>
                                <div class="sms-log-text">{{ item.text }}</div>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{item.to}}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{formatDateTime(item.sent_at)}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </div>
            </template>
        </v-list>
    </v-card>
</template>
<script>

    import {formatDateTime} from "@/helpers";

    export default {
        name: 'sms-log',
        props: {
            carId: Number
        },


        data() {
            return {
                loading: false,
                smsLog: []
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            formatDateTime,
            loadData() {
                this.loading = true;

                let params = {car: this.carId};

                this.$http.get('sms/car', {params}).then(response => {
                    this.smsLog = response.data.data;
                }).finally(() => this.loading = false);
            }
        },
    }
</script>

<style scoped>
    .sms-log-text {
        white-space: pre-line;
        line-height: 120%;
        padding: 0.5rem 0;
        max-height: 200px;
        overflow-y: auto;
    }

</style>
